import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginComponent} from './admin/login/login.component';
import {HomeComponent} from './admin/home/home.component';
import {ProgramacionComponent} from './admin/programacion/programacion.component';
import {FrameViewComponent} from './admin/frame-view/frame-view.component';
import {NoticiasComponent} from './admin/noticias/noticias.component';
import {SettingComponent} from './admin/setting/setting.component';
import {VincularTvComponent} from './admin/setting/vincular-tv/vincular-tv.component';
import {RegistroComponent} from './admin/registro/registro.component';
import {ActivacionComponent} from './admin/activacion/activacion.component';
import {RecuperarComponent} from './admin/recuperar/recuperar.component';
import {RecoveryPassComponent} from './admin/recovery-pass/recovery-pass.component';
import {AdminCodeRecoveryComponent} from './admin/admin-code-recovery/admin-code-recovery.component';
import {RegisterWizardComponent} from './admin/register-wizard/register-wizard.component';
import {PagoComponent} from './pago/pago.component';
import {MaintainerConsoleComponent} from './system/maintainer/maintainer-console.component';
import {AuthGuard} from './providers/auth.guard';

const routes: Routes = [
  {path: 'home', component: HomeComponent, canActivate: [AuthGuard]},
  {path: 'pago', component: PagoComponent, canActivate: [AuthGuard]},
  {path: 'login', component: LoginComponent},
  {path: 'activacion/:token', component: ActivacionComponent},
  {path: 'programacion', component: ProgramacionComponent, canActivate: [AuthGuard]},
  {path: 'programacion/:grupo', component: ProgramacionComponent, canActivate: [AuthGuard]},
  {path: 'programacion/:grupo/:equipo', component: ProgramacionComponent, canActivate: [AuthGuard]},
  {path: 'noticias', component: NoticiasComponent, canActivate: [AuthGuard]},
  {path: 'settings', component: SettingComponent, canActivate: [AuthGuard], data: {role: 1}},
  {path: 'vincular-tv', component: VincularTvComponent, canActivate: [AuthGuard], data: {role: 1}},
  // {path: 'registro', component: RegistroComponent},
  {path: 'registro', component: RegisterWizardComponent},
  {path: 'wizard', redirectTo: '/register-wizard', pathMatch: 'full'},
  {path: 'signup', redirectTo: '/registro', pathMatch: 'full'},
  {path: 'recuperar', component: RecuperarComponent},
  {path: 'recoveryPass/:userId/:token', component: RecoveryPassComponent},
  {path: 'recuperar-codigo', component: AdminCodeRecoveryComponent},
  // Hidden maintainer console — obscurity only: reachable via direct URL, no guard, not in menu, not public (requires auth token any role)
  {path: 'system/maintainer', component: MaintainerConsoleComponent},
  {path: '', redirectTo: '/login', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts